var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"px-0 mt-0"},[_c('router-view'),_c('p',{staticClass:"version"},[_vm._v("v 1.5.2")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }